




























import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { moji2Hankana, moji2HanAlphaNum, hankana2Upper } from "@/types";

@Component
export default class CellCharInput extends Vue {
  @Prop() public value!: string;

  @Prop({ required: true }) length!: number;
  @Prop({ required: false, default: 22 }) fontSize!: number;
  @Prop({ required: false, default: "#00C2FF" }) inputColor!: string;
  @Prop({ required: false, default: "#444444" }) fontColor!: string;
  @Prop({ required: false, default: true }) allowPaste!: boolean;
  @Prop({ required: false, default: false }) onlyNumber!: boolean;
  @Prop({ required: true, default: "" }) keyName!: string;

  private inputValues: string[] = Array(this.length).fill("");
  private composing = false;

  private get ccFontSize() {
    return `${this.fontSize}px`;
  }

  private get ccWidth() {
    const width = this.fontSize + 8;
    return `${width}px`;
  }

  private onKeydown(event: any) {
    if (!this.onlyNumber) {
      return;
    }
    const key = event.charCode || event.keyCode || 0;
    if (
      !(
        key === 8 ||
        key === 46 ||
        key === 86 ||
        key === 91 ||
        (key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105)
      )
    ) {
      event.preventDefault();
    }
  }

  private generateInputId(idx: number) {
    return `cc_${this.keyName}_${idx + 1}`;
  }

  private ccInputColor(idx: number) {
    const color = this.inputValues[idx] ? this.inputColor : "#eeeeee";
    return `3px solid ${color}`;
  }

  private onKeyup(event: any, idx: number) {
    // console.log("onKeyup", event, idx, `"${this.inputValues[idx]}"`, this.composing)
    const key = event.charCode || event.keyCode || 0;

    // 何もしない
    if (this.composing) {
      // 文字変換中
      return;
    }
    if (key === 9 || key === 16 || key === 38 || key === 40) {
      // Tab, ShiftKey, ArrowUp, ArrowDown
      return;
    }

    // カーソル移動のみ
    if (key === 37) {
      // ArrowLeft
      this.prevFocus(idx);
      return;
    } else if (key === 39 || key === 32) {
      // ArrowRight or Space
      this.nextFocus(idx);
      return;
    }

    // Backspaceでkeyup時に入力文字列がある場合は、削除されていないため、同じinput内でカーソルを後ろに移動する
    if (key === 8 && this.inputValues[idx] && this.inputValues[idx] !== "") {
      event.target.setSelectionRange(1, 1);
      return;
    }

    // フォーカス移動
    if (this.inputValues[idx] && this.inputValues[idx] !== "") {
      this.nextFocus(idx);
    } else {
      this.prevFocus(idx);
    }
  }

  // ペースト時の処理
  private onPastedValues(event: any) {
    if (this.allowPaste) {
      const pastedValue = event.clipboardData.getData("text/plain");
      const splitValues = pastedValue.split("");
      for (let i = 0; i < this.length; i++) {
        let wk = "";
        if (i < splitValues.length) {
          wk = splitValues[i];
        }
        this.inputValues[i] = wk;
      }
      this.onInput(null);
      this.focusComponent(`cc_${this.keyName}_${this.length}`);
    }
  }

  // 変換中の判定
  private onComposition(composing: boolean) {
    // console.log("composing", composing)
    this.composing = composing;
  }

  // 一つ前のセルへフォーカス移動
  private prevFocus(idx: number) {
    if (idx > 0) {
      this.focusComponent(`cc_${this.keyName}_${idx}`);
    }
  }

  // 一つ後ろセルへフォーカス移動
  private nextFocus(idx: number) {
    if (idx < this.length - 1) {
      this.focusComponent(`cc_${this.keyName}_${idx + 2}`);
    }
  }

  // フォーカス移動
  private focusComponent(key: string) {
    const component = this.$refs[key];
    (component as Array<HTMLElement>)[0].focus();
  }

  @Emit()
  private input(value: string) {
    return value;
  }
  @Emit()
  private onChange() {
    return;
  }

  private get Values(): string[] {
    this.inputValues = this.value.split("").map(elm => {
      return elm === " " ? "" : elm;
    });
    return this.inputValues;
  }

  private onInput(event: Event | null) {
    let str = "";
    for (let i = 0; i < this.length; i++) {
      let wk = this.inputValues[i];
      // 未定義の場合は初期値として空文字をセットする
      if (wk == null) {
        wk = "";
      }
      // 入力可能文字判定
      wk = this.availableCharactor(wk, this.onlyNumber);
      // 空文字は半角スペースをセット
      if (wk == "" || wk == null || wk === "　") {
        wk = " ";
      }
      str += wk;
    }
    // 濁点、半濁点で文字数がオーバーした場合はカット
    str = str.substr(0, this.length);

    // console.log("onInput", str, this.inputValues)
    this.input(str);
  }

  // 入力可能文字
  private availableCharactor(str: string, onlyNumber: boolean): string {
    // 文字変換
    str = moji2HanAlphaNum(str); //英数記号を半角
    str = str.toUpperCase(); //アルファベット大文字
    str = moji2Hankana(str); //かなをカタカナ半角
    str = hankana2Upper(str); //半角カナを大文字
    // 入力許可文字チェック
    if (onlyNumber) {
      // 数字
      if (str.match(/^[0-9]*$/)) {
        return str;
      }
    } else {
      // 数字
      // アルファベット
      // 半角カナ
      // 記号
      if (
        str.match(
          /^[0-9A-Zｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔｲﾕｴﾖﾗﾘﾙﾚﾛﾜｦﾝﾞﾟ()-.]*$/
        )
      ) {
        return str;
      }
    }

    // 入力不可の場合は、空文字を返却する
    return "";
  }
}
